import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/base.scss';
import App from './App';
import './i18n'; // Initialize i18n

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
